export enum SnackBarTypesEnum{
    SUCCESS,
    ERROR
}
